// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.note-select-row {
  margin-top: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.note-out-of {
  margin-left: 0.5rem;
}

.text-other-user {
  max-height: 200px;
  overflow-y: auto;
  padding: 10px;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  background-color: rgba(215, 217, 217, 0.2);
  margin-bottom: 10px;
  white-space: pre-wrap;
  word-break: break-word;
}

.pdf-button {
  margin-top: 1rem !important;
  margin-bottom: 2rem !important;
  z-index: 1;
}

.text-other-user.finance {
  text-align: right;
}

/* Styles pour les offres expirées */
.expired-notice {
  padding: 1rem;
  background-color: #f5f5f5;
  color: #555;
  border-left: 4px solid #888;
  margin-bottom: 1rem;
  /* font-style: italic; */
}

.expired-badge {
  background-color: #777;
  color: white;
  /* font-size: 0.7rem; */
  padding: 0.2rem 0.4rem;
  border-radius: 3px;
  margin-left: 0.5rem;
  font-weight: 400;
  position: absolute;
  top: 10px;
  right: 10px;
}

.expired-badge-small {
  background-color: #777;
  color: white;
  font-size: 0.65rem;
  padding: 0.1rem 0.3rem;
  border-radius: 2px;
  margin-left: 0.3rem;
  font-weight: 400;
}

/* Style grisé pour les prestataires expirés */
.presta-col.disabled {
  opacity: 0.85;
  position: relative;
  background-color: #f9f9f9;
}

.presta-col.disabled::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(240, 240, 240, 0.3);
  pointer-events: none;
}

.analyse-info {
  padding: 2rem 0rem !important;
}
@media print {
  .analyse-info {
    margin: 0 0 0.5rem 0;
    page-break-inside: avoid;
  }

  .presta-col {
    display: flex !important;
    flex-direction: column !important;
    height: 100% !important;
  }

  .presta-content {
    flex-grow: 1 !important;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  /* On retire les marges inutiles pour éviter tout décalage */
  .presta-col > * {
    margin: 0 !important;
    width: 100% !important;
  }
  .presta-footer-right.pdf-button {
    margin: 0 auto !important;
  }
  /* Footer (la note) toujours collé en bas */
  .presta-footer {
    margin-top: auto !important; /* pousse vers le bas */
    align-self: end !important; /* garantit la position bas */
  }
}
`, "",{"version":3,"sources":["webpack://./src/composants/AnalyseOffreTechnique/AnalyseOffreTechnique.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,2BAA2B;EAC3B,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE;IACE,oBAAoB;IACpB,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;IACxB,iCAAiC;IACjC,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA,4DAA4D;EAC5D;IACE,oBAAoB;IACpB,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA,2CAA2C;EAC3C;IACE,2BAA2B,EAAE,uBAAuB;IACpD,0BAA0B,EAAE,6BAA6B;EAC3D;AACF","sourcesContent":[".note-select-row {\n  margin-top: 1rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.note-out-of {\n  margin-left: 0.5rem;\n}\n\n.text-other-user {\n  max-height: 200px;\n  overflow-y: auto;\n  padding: 10px;\n  border: 1px solid #e5e7eb;\n  border-radius: 4px;\n  background-color: rgba(215, 217, 217, 0.2);\n  margin-bottom: 10px;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.pdf-button {\n  margin-top: 1rem !important;\n  margin-bottom: 2rem !important;\n  z-index: 1;\n}\n\n.text-other-user.finance {\n  text-align: right;\n}\n\n/* Styles pour les offres expirées */\n.expired-notice {\n  padding: 1rem;\n  background-color: #f5f5f5;\n  color: #555;\n  border-left: 4px solid #888;\n  margin-bottom: 1rem;\n  /* font-style: italic; */\n}\n\n.expired-badge {\n  background-color: #777;\n  color: white;\n  /* font-size: 0.7rem; */\n  padding: 0.2rem 0.4rem;\n  border-radius: 3px;\n  margin-left: 0.5rem;\n  font-weight: 400;\n  position: absolute;\n  top: 10px;\n  right: 10px;\n}\n\n.expired-badge-small {\n  background-color: #777;\n  color: white;\n  font-size: 0.65rem;\n  padding: 0.1rem 0.3rem;\n  border-radius: 2px;\n  margin-left: 0.3rem;\n  font-weight: 400;\n}\n\n/* Style grisé pour les prestataires expirés */\n.presta-col.disabled {\n  opacity: 0.85;\n  position: relative;\n  background-color: #f9f9f9;\n}\n\n.presta-col.disabled::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(240, 240, 240, 0.3);\n  pointer-events: none;\n}\n\n.analyse-info {\n  padding: 2rem 0rem !important;\n}\n@media print {\n  .analyse-info {\n    margin: 0 0 0.5rem 0;\n    page-break-inside: avoid;\n  }\n\n  .presta-col {\n    display: flex !important;\n    flex-direction: column !important;\n    height: 100% !important;\n  }\n\n  .presta-content {\n    flex-grow: 1 !important;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  /* On retire les marges inutiles pour éviter tout décalage */\n  .presta-col > * {\n    margin: 0 !important;\n    width: 100% !important;\n  }\n  .presta-footer-right.pdf-button {\n    margin: 0 auto !important;\n  }\n  /* Footer (la note) toujours collé en bas */\n  .presta-footer {\n    margin-top: auto !important; /* pousse vers le bas */\n    align-self: end !important; /* garantit la position bas */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
